import classNames from "classnames"
import type { MouseEvent } from "react"

interface AudioIconProps {
  className?: string
}

const AudioIcon = ({ className }: AudioIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.9"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
  >
    <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" />
    <path d="M15.5 8.5a5 5 0 0 1 0 7" />
    <path d="M18.5 6a8.5 8.5 0 0 1 0 12" />
  </svg>
)

const MutedAudioIcon = ({ className }: AudioIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.9"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
  >
    <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" />
    <line x1="22" y1="9" x2="16" y2="15" />
    <line x1="16" y1="9" x2="22" y2="15" />
  </svg>
)

export interface MuteButtonProps {
  isMuted: boolean
  onClick: (event: MouseEvent<HTMLButtonElement>) => void
  className?: string
  iconClassName?: string
}

const MuteButton = ({
  isMuted,
  onClick,
  className,
  iconClassName = "h-4 w-4"
}: MuteButtonProps) => (
  <button
    type="button"
    onClick={onClick}
    aria-label={isMuted ? "Unmute video" : "Mute video"}
    className={classNames(
      "pointer-events-auto inline-flex flex-shrink-0 items-center justify-center text-white transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white",
      className
    )}
  >
    {isMuted ? (
      <MutedAudioIcon className={iconClassName} />
    ) : (
      <AudioIcon className={iconClassName} />
    )}
  </button>
)

MuteButton.displayName = "MuteButton"

export { MuteButton }
export default MuteButton
